import { Link } from "react-router-dom";
import { comicCategories } from "@/mocks/comicData";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-white"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950 font-heading">
                虚空韩漫网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫在线免费看，韩漫免费漫画在线观看，下拉式免费阅读体验。致力于为中国韩漫爱好者提供最优质的阅读服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {comicCategories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={cat.slug === "all" ? "/category/all" : `/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  全部漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base w-4 h-4 flex items-center justify-center"></i>
                contact@xukongmanhua.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-wechat-line text-base w-4 h-4 flex items-center justify-center"></i>
                虚空韩漫网
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-time-line text-base w-4 h-4 flex items-center justify-center"></i>
                周一至周五 9:00-18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2022-2026 虚空韩漫网. 韩漫在线免费看，韩漫免费漫画在线观看下拉式免费阅读.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}